import React from 'react'
import cn from 'classnames'

export default function Member(props) {
    const { content, shouldHandleDelete } = props

    return (
        <div key={content} className={cn('user-tag is-info', props.className)}>
            {content}
            {shouldHandleDelete && (
                <div className="small-delete">
                    <i
                        className="fa fa-times-circle"
                        style={{ marginLeft: '5px', cursor: 'pointer' }}
                        onClick={props.handleDelete}
                    />
                </div>
            )}
        </div>
    )
}
